import { render, staticRenderFns } from "./BusinessMemberInformation.vue?vue&type=template&id=36661ee2"
import script from "./BusinessMemberInformation.vue?vue&type=script&lang=js"
export * from "./BusinessMemberInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports